document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.card-swatch-trigger');
  if (!trigger) return;
  e.preventDefault();
  e.stopPropagation();
  const imageUrl = trigger.dataset.imageUrl;
  if (!imageUrl) return;
  const card = trigger.closest('[class*="card__media"]');
  if (!card) return;
  const img = card.querySelector('img');
  if (img) img.src = imageUrl;
}, true); // <-- 'true' uses capture phase, fires BEFORE the link click
